exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* stylelint-disable */\n\n/* ==========================================================================\n   Carousel\n   ========================================================================== */\n.carousel {\n  position: relative; }\n\n/* Slides\n   ========================================================================== */\n.carousel__slides-wrapper {\n  overflow: hidden;\n  position: relative; }\n  .carousel__slides-wrapper--shadow {\n    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 5px 0 rgba(0, 0, 0, 0.16); }\n\n.carousel__slides {\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n\n.carousel__slide {\n  display: none;\n  flex: 1 0 100%;\n  justify-content: center;\n  align-items: center;\n  list-style-type: none; }\n  .carousel__slide--active {\n    display: flex; }\n\n/* Arrows\n   ========================================================================== */\n.carousel__arrow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 45px;\n  height: 45px;\n  background-color: #fff;\n  color: #25b8d2;\n  opacity: 0.85;\n  box-shadow: 0 6px 17px 0 rgba(0, 0, 0, 0.16), 0 8px 14px 0 rgba(0, 0, 0, 0.18);\n  border-radius: 50%;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  z-index: 1; }\n  .carousel__arrow--left {\n    left: -17px; }\n  .carousel__arrow--right {\n    right: -17px; }\n  .carousel__arrow:hover {\n    color: #1797ae;\n    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 5px 0 rgba(0, 0, 0, 0.16);\n    opacity: 1; }\n\n/* Slides indicators\n   ========================================================================== */\n.carousel__indicators {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: 10px; }\n\n.carousel__indicator {\n  display: block;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  cursor: pointer;\n  background-color: #fff; }\n  .carousel__indicator:hover {\n    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 5px 0 rgba(0, 0, 0, 0.16);\n    background-color: #1797ae; }\n  .carousel__indicator--active, .carousel__indicator:active {\n    background-color: #57d0dd;\n    box-shadow: none; }\n  .carousel__indicator:nth-of-type(n + 2) {\n    margin-left: 10px; }\n\n/* ==========================================================================\n   Animations\n   ========================================================================== */\n.carousel-next-animation-translate-enter {\n  transform: translateX(100%); }\n\n.carousel-next-animation-translate-enter-active {\n  transform: translateX(0);\n  transition: transform 300ms ease-in; }\n\n.carousel-next-animation-translate-exit {\n  display: flex;\n  transition: transform 300ms ease-in;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0; }\n\n.carousel-next-animation-translate-exit-active {\n  transform: translateX(-100%);\n  transition: transform 300ms ease-in; }\n\n.carousel-prev-animation-translate-enter {\n  transform: translateX(-100%); }\n\n.carousel-prev-animation-translate-enter-active {\n  transform: translateX(0);\n  transition: transform 300ms ease-in; }\n\n.carousel-prev-animation-translate-exit {\n  display: flex;\n  transition: transform 300ms ease-in;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0; }\n\n.carousel-prev-animation-translate-exit-active {\n  transform: translateX(100%);\n  transition: transform 300ms ease-in; }\n", ""]);

// exports
exports.locals = {
	"color-groups": "base | colors | primary | semantic | chart",
	"colors-white": "#fff",
	"colors-red": "#f54545",
	"colors-green": "#6acb4c",
	"colors-body-color": "#363636",
	"colors-grey-90": "#444",
	"colors-grey-80": "#666",
	"colors-grey-70": "#858484",
	"colors-grey-60": "#a4a4a4",
	"colors-grey-50": "#c2c2c2",
	"colors-grey-40": "#ddd",
	"colors-grey-30": "#ececec",
	"colors-grey-20": "#f2f2f2",
	"colors-grey-10": "#f8f8f8",
	"colors-black": "#000",
	"base-brown-100": "#343230",
	"base-brown-80": "#474340",
	"base-brown-60": "#61554c",
	"base-brown-40": "#998673",
	"base-brown-20": "#c1aa95",
	"base-earth-100": "#bbb6af",
	"base-earth-80": "#c7c1b8",
	"base-earth-60": "#d7cebf",
	"base-earth-40": "#eae4db",
	"base-earth-20": "#e9e7db",
	"base-earth-10": "#f7f5eb",
	"primary-romantic-purple-base": "#834ba2",
	"primary-romantic-purple-dark": "#5a3770",
	"primary-romantic-purple-light": "#ab83c4",
	"primary-sky-blue-base": "#25b8d2",
	"primary-sky-blue-dark": "#1797ae",
	"primary-sky-blue-light": "#57d0dd",
	"primary-mint-base": "#3fc798",
	"primary-mint-dark": "#2cab7f",
	"primary-mint-light": "#79dbb5",
	"primary-grassy-base": "#96cb4c",
	"primary-grassy-dark": "#81a03c",
	"primary-grassy-light": "#b7dd7a",
	"primary-desert-sunset-base": "#eca03e",
	"primary-desert-sunset-dark": "#c2802a",
	"primary-desert-sunset-light": "#fbc75c",
	"primary-salmon-base": "#f57b45",
	"primary-salmon-dark": "#d45e2a",
	"primary-salmon-light": "#ef9a78",
	"semantic-color-primary": "#f57b45",
	"semantic-color-primary-hovered": "#d45e2a",
	"semantic-color-primary-active": "#ef9a78",
	"semantic-color-secondary": "#25b8d2",
	"semantic-color-secondary-hovered": "#1797ae",
	"semantic-color-secondary-active": "#57d0dd",
	"semantic-color-light": "#fff",
	"semantic-color-light-hovered": "#fff",
	"semantic-color-light-active": "#fff",
	"semantic-color-dark": "#f8f8f8",
	"semantic-color-dark-hovered": "#f2f2f2",
	"semantic-color-dark-active": "#f8f8f8",
	"semantic-color-error": "#f54545",
	"semantic-color-success": "#6acb4c",
	"semantic-color-warning": "#eca03e",
	"semantic-color-instruction": "#25b8d2",
	"semantic-color-info": "#834ba2",
	"semantic-color-hint": "#c2c2c2",
	"chart-first": "#25b8d2",
	"chart-second": "#f57b45",
	"chart-third": "#96cb4c",
	"chart-fourth": "#eca03e",
	"chart-fifth": "#3fc798",
	"chart-sixth": "#ab83c4",
	"chart-seventh": "#c1aa95",
	"chart-eighth": "#c2c2c2"
};